import Dexie, { type EntityTable } from 'dexie';
import type { RelationshipTag, SnippetIndexRecord, Tag } from './schema';

const tagsDb = new Dexie('TagDatabase') as Dexie & {
    tags: EntityTable<Tag, 'id'>;
    relationshipTags: EntityTable<RelationshipTag, 'id'>;
    snippetIndex: EntityTable<SnippetIndexRecord, 'id'>;
};

tagsDb.version(1).stores({
    tags: 'id, children, count, booksUsingTag, attributes',
    relationshipTags: 'id, parent, child, entries',
    snippetIndex: 'id',
});

export { tagsDb };
